import { render, staticRenderFns } from "./tag-button.vue?vue&type=template&id=826e1036&"
import script from "./tag-button.vue?vue&type=script&lang=js&"
export * from "./tag-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports